import { ApplicantStatus } from "@/services/constants/applicant";
import {
  DATE_TIME_FORMAT_DEFAULT,
  DATE_TIME_FORMAT_YYYYMMDDHHMM,
} from "@/services/constants/global";
import {
  durationFormatter,
  formatDate,
  upperSnakeCaseToNormalCase,
} from "@/services/utils/formatter";
import { calculateAge, splitStringData } from "@/services/utils/general";
import { get } from "lodash";

export const parsedApplicantModel = (applicant) => {
  const applicantContact = `${get(applicant, "resume.fullName")} ${
    calculateAge(applicant.resume?.birthday) &&
    `(${calculateAge(applicant.resume?.birthday)} years old)`
  }`;

  const status =
    applicant.status === ApplicantStatus.NONE
      ? ""
      : upperSnakeCaseToNormalCase(applicant.status);

  return {
    ...applicant,
    videoInterviewJudgement: get(applicant, "videoInterviewJudgement") || "--",
    career: get(applicant, "resume.career.name") || "--",
    firstInterviewStatus:
      upperSnakeCaseToNormalCase(get(applicant, "interviews[0].status")) ||
      "--",
    firstInterviewDate:
      formatDate(
        get(applicant, "interviews[0].dateStartInterview"),
        DATE_TIME_FORMAT_YYYYMMDDHHMM
      ) || "--",
    secondInterviewStatus:
      upperSnakeCaseToNormalCase(get(applicant, "interviews[1].status")) ||
      "--",
    secondInterviewDate:
      formatDate(
        get(applicant, "interviews[1].dateStartInterview"),
        DATE_TIME_FORMAT_YYYYMMDDHHMM
      ) || "--",
    applicantContact: applicantContact || "--",
    jobTitle: applicant.job.recruitmentName || "--",
    status: status || "--",
    createdAt: formatDate(applicant.createdAt),
    result: upperSnakeCaseToNormalCase(get(applicant, "interviews[1].result")),
  };
};

export const parsedAppliedJobModel = (appliedJob) => {
  const convertedInterviews = appliedJob.interviews.map((interview) => ({
    ...interview,
    timeStartInterview: formatDate(
      interview.dateStartInterview,
      DATE_TIME_FORMAT_DEFAULT
    ),
    durationInterview: durationFormatter([
      interview.durationHours,
      interview.durationMinutes,
    ]),
    status:
      appliedJob.status === ApplicantStatus.NONE
        ? ""
        : upperSnakeCaseToNormalCase(interview.status),
    result: upperSnakeCaseToNormalCase(interview.result),
  }));

  return {
    ...appliedJob,
    createdAt: formatDate(appliedJob.createdAt),
    status:
      appliedJob.status === ApplicantStatus.NONE
        ? ""
        : upperSnakeCaseToNormalCase(appliedJob.status),
    interviews: convertedInterviews,
    interviewStatus: convertedInterviews.length
      ? convertedInterviews.map((interview) => interview.status || "--")
      : ["--"],
    interviewResults: convertedInterviews.length
      ? convertedInterviews.map((interview) => interview.result)
      : [],
  };
};

export const parsedApplicantResumeModel = (resume) => {
  return {
    ...resume,
    skillsArr: splitStringData(get(resume, "skills")),
    certificatesArr: splitStringData(get(resume, "certificates")),
    awardsArr: splitStringData(get(resume, "awards")),
  };
};
